export default {"src":"/_next/static/media/MRDB.51504158.svg","height":18,"width":18};